import { Box, Checkbox, darken, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CheckboxFieldworker } from "./CheckboxFieldworker";

const TRAVEL_METHODS = ["privateCar", "myWheels", "bike"] as const;

export function FieldworkerTravelMethodFilter({
    selectedMethods,
    onChange,
}: {
    selectedMethods: string[];
    onChange: (method: string, checked: boolean) => void;
}) {
    const { t } = useTranslation("plannerV2");

    return (
        <Box margin={2} marginBlockEnd={0} sx={theme => ({ border: `1px solid ${theme.palette.divider}` })}>
            {TRAVEL_METHODS.map(method => (
                <Box key={method}>
                    <FormControlLabel
                        label={t(`travelMethod.${method}`)}
                        key={method}
                        sx={theme => ({
                            margin: 0,
                            display: "flex",
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            "&:hover": {
                                backgroundColor: darken(theme.palette.background.paper, 0.03),
                            },
                        })}
                        control={
                            <Checkbox
                                checked={selectedMethods.includes(method)}
                                icon={<CheckboxFieldworker checked={false} variant={method} />}
                                checkedIcon={<CheckboxFieldworker checked={true} variant={method} />}
                            />
                        }
                        onChange={(_event, checked) => onChange(method, checked)}
                    />
                </Box>
            ))}
        </Box>
    );
}
